import React from "react";
import './_styles.scss';

const AddButton = () => (<img src="/img/plus.png" className="plus-icon"/>);

export default AddButton;

